import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './features/auth/pages/LoginPage/LoginPage';
import Home from './features/home/pages/Home/Home';
import RegisterPage from './features/auth/pages/RegisterPage/RegisterPage';
import DashboardPage from './features/dashboard/pages/DashboardPage/DashboardPage';
import ProtectedRoute from './components/ProtectedRoute';
import PublicRoute from './components/PublicRoute';

function App() {
    return (
        <div className="dark">
            <BrowserRouter>
                <Routes>
                    <Route path="/login"
                        element={<PublicRoute><LoginPage /></PublicRoute>}
                    />
                    <Route path="/register"
                        element={<PublicRoute><RegisterPage /></PublicRoute>}
                    />
                    <Route path="/dashboard"
                        element={<ProtectedRoute><DashboardPage /></ProtectedRoute>}
                    />
                    <Route path="/"
                        element={<PublicRoute><Home /></PublicRoute>}
                    />
                    <Route path="*" 
                        element={<Navigate to="/" replace />} 
                    />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;